module.exports = __webpack_public_path__ + "img/AF_GusmãoLabrunie_Icones_plant-varieties-cultivars.0a2018c3.png";